//
//
//
//
//
//
//

import FixedWireless from './FixedWireless'
import GQL from './gql'
import Poi from '@/views/services/overview/Poi'

export default {
  components: {
    Poi,
    FixedWireless
  },

  apollo: {
    service: GQL.service
  },

  data() {
    return {
      service: null
    }
  },

  computed: {
    serviceReference() {
      return this?.service?.product?.service_reference
    },

    isFixedWireless() {
      const serviceReference = this.serviceReference
      const reference = ['NET', 'DCI', 'SFI', 'VPE', 'DCV', 'SFV']
      return reference.includes(serviceReference)
    },

    isPOI() {
      const serviceReference = this.serviceReference
      return serviceReference === 'POI'
    }
  }
}
